import operandType from '../../../../infrastructure/constants/functions/operandType';
import SelectOption from '../../../../infrastructure/types/SelectOption';

const firdsResultSetOptions: SelectOption[] = [
    { text: 'ESMA', value: operandType.firdsResultSetEsma },
    { text: 'FCA', value: operandType.firdsResultSetFca },
];

export { firdsResultSetOptions }